import React, { useState } from "react";
import Footer from "../../components/Footer/Footer";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { Link } from "react-router-dom";
import CashboxManual from "../../Assets/Pdf/CASHBOX.pdf"
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import DownloadIcon from '@mui/icons-material/Download';
import Video11 from "../../Assets/Video/Video11.MP4"
import Video12 from "../../Assets/Video/Video12.MP4"
import Video13 from "../../Assets/Video/Video13.mp4"
import Video14 from "../../Assets/Video/Video14.MP4"
import Video15 from "../../Assets/Video/Video15.MP4"
import Instruksiya1 from "../../Assets/Video/Instruksiya1.mp4"
import Instruksiya2 from "../../Assets/Video/Instruksiya2.mp4"

function Manual() {
  const [activePage, setActivePage] = useState(false)
  return (
    <div id="manual">
      <div className="py-40 bg-[#3C31A2]">
        <h2
          data-aos="zoom-in"
          className="text-white leading-[50px] sm:leading-normal font-bold text-[50px] text-center"
        >
          Руководство пользования
        </h2>
      </div>
      <div className="py-6 bg-[#2F2C3D]">
        <div className="2xl:container px-5 mx-auto flex items-center space-x-1 text-white">
          <Link className="border-b-2 border-white" to={"/"}>
            Главный
          </Link>
          <DoubleArrowIcon style={{ inlineSize: "20px", blockSize: "20px" }} />
          <span className="text-center inline-block">Руководство пользования</span>
          <DoubleArrowIcon style={{ inlineSize: "20px", blockSize: "20px" }} />
          <span className="text-center inline-block">{activePage ? "Видео инструкция" : "Инструкция"}</span>
        </div>
      </div>
      <div className="pb-16 px-5 lg:px-0 sm:pb-20 bg-[#262431]">
        <ul className="py-5 lg:container relative cursor-pointer text-white mx-auto flex items-center space-x-5">
          <li onClick={() => setActivePage(false)} className={`${activePage ? "text-white border-white" : "text-[#00C9DB] border-[#00C9DB]"} hover:scale-110 hover:text-[#00C9DB] hover:border-[#00C9DB] transition border-b-[2px]`}>Инструкция</li>
          <li onClick={() => setActivePage(true)} className={`${activePage ? "text-[#00C9DB] border-[#00C9DB]" : "text-white border-white"} hover:scale-110 hover:text-[#00C9DB] hover:border-[#00C9DB] transition border-b-[2px]`}>Видео инструкция</li>
        </ul>
        <div className="flex lg:container mx-auto items-start lg:space-x-10 justify-center sm:justify-between">
          {activePage ?
            <div className="w-full">
              <ul className="flex justify-center sm:justify-center gap-10 flex-wrap">
                <li data-aos="zoom-in-up" className="bg-[#6F42C1] mt-5 w-[250px] rounded-md">
                  <video className="rounded-tr-md rounded-tl-md" controls>
                    <source src={Video11} type="video/mp4" />
                  </video>
                  <p className="text-[15px] text-white font-semibold p-1 text-start">Руководство по добавлению товара</p>
                </li>
                <li data-aos="zoom-in-up" className="bg-[#6F42C1] w-[250px] mt-5 rounded-md">
                  <video className="rounded-tr-md rounded-tl-md" controls>
                    <source src={Video12} type="video/mp4" />
                  </video>
                  <p className="text-[15px] text-white font-semibold p-1 text-start">Как подключить сканер к аппарату через блютуз</p>
                </li>
                <li data-aos="zoom-in-up" className="bg-[#6F42C1] mt-5 w-[250px] rounded-md">
                  <video className="rounded-tr-md rounded-tl-md" controls>
                    <source src={Video13} type="video/mp4" />
                  </video>
                  <p className="text-[15px] text-white mt-5 font-semibold p-1 text-start">Продажа</p>
                </li>
                <li data-aos="zoom-in-up" className="bg-[#6F42C1] w-[250px] mt-5 rounded-md">
                  <video className="rounded-tr-md rounded-tl-md" controls>
                    <source src={Video14} type="video/mp4" />
                  </video>
                  <p className="text-[15px] text-white font-semibold p-1 text-start">Как изменить язык интерфейса</p>
                </li>
                <li data-aos="zoom-in-up" className="bg-[#6F42C1] w-[250px] mt-5 rounded-md">
                  <video className="rounded-tr-md rounded-tl-md" controls>
                    <source src={Video15} type="video/mp4" />
                  </video>
                  <p className="text-[15px] text-white font-semibold p-1 text-start">Как обновить базу?</p>
                </li>
                <li data-aos="zoom-in-up" className="bg-[#6F42C1] w-[250px] mt-5 rounded-md">
                  <video className="rounded-tr-md rounded-tl-md" controls>
                    <source src={Instruksiya1} type="video/mp4" />
                  </video>
                  <p className="text-[15px] text-white font-semibold p-1 text-start">Добавить товара с единицы измерениями</p>
                </li>
                <li data-aos="zoom-in-up" className="bg-[#6F42C1] w-[250px] mt-5 rounded-md">
                  <video className="rounded-tr-md rounded-tl-md" controls>
                    <source src={Instruksiya2} type="video/mp4" />
                  </video>
                  <p className="text-[15px] text-white font-semibold p-1 text-start">Изменение единицы измерения товара</p>
                </li>
              </ul>
            </div>
            :
            <div className="flex justify-center lg:justify-between items-start w-full">
              <embed
                data-aos="zoom-in"
                className='hidden lg:flex'
                src={CashboxManual}
                style={{
                  border: '1px solid rgba(0, 0, 0, 0.3)',
                  "blockSize": '1000px',
                  'inlineSize': '65%'
                }}
              />
              <a data-aos="zoom-in-up" className='text-white border-b-[1px] border-white hover:text-blue-300 hover:border-blue-300 space-x-3 py-[1.5px] lg:w-[32%] flex justify-between items-center' href={CashboxManual} download={CashboxManual}>
                <span>Руководство пользования</span>
                <DownloadIcon />
              </a>
            </div>
          }
        </div>
      </div>
      <Footer bg={true} />
      <a href={'#manual'} className='w-[42px] z-50 rotate-90 duration-200 fixed right-5 bottom-5 h-[42px] text-white flex items-center justify-center rounded-[50%] bg-[#00C9DB] hover:bg-[#73e5f0]'>
        <ArrowBackIosNewIcon />
      </a>
    </div>
  );
}

export default Manual;
